import appConfig from '../../config/app';
import { getAuthHeaders } from './auth';

const buildNewsFeedEndpoints = (gymUid) => [
  `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/news_posts`,
];

const normalizePosts = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.posts)) {
    return payload.posts;
  }

  if (Array.isArray(payload?.news_posts)) {
    return payload.news_posts;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export async function fetchGymNewsFeed(gymUid) {
  if (!gymUid) {
    return [];
  }

  const options = await getAuthHeaders();
  const endpoints = buildNewsFeedEndpoints(gymUid);

  for (const endpoint of endpoints) {
    try {
      const response = await fetch(endpoint, {
        headers: {
          ...options,
        },
      });

      if (response.ok) {
        const payload = await response.json();
        return normalizePosts(payload);
      }

      if (response.status !== 404) {
        const payload = await response.json().catch(() => null);
        throw new Error(payload?.error || 'Unable to load news feed');
      }
    } catch (error) {
      if (endpoint === endpoints[endpoints.length - 1]) {
        throw error;
      }
    }
  }

  return [];
}
